import React from "react";
import "./FeatureSection1.css";
import { Link } from "react-router-dom";

import exampleImage1 from "../../assets/images/ChooseStory.png";
import exampleImage2 from "../../assets/images/ReadStory.png";
import exampleImage3 from "../../assets/images/TestStory.png";
import exampleImage4 from "../../assets/images/BoostVocab.png";

const FeatureSection1 = () => {
  return (
    <section className="features-section" aria-labelledby="features-title">
      {/* Header */}
      <header className="features-header">
        <h2 id="features-title" className="features-title">
          Como o <span className="shiny-text">Aprendole</span> funciona
        </h2>
        {/* <p className="features-subtitle">
          Escolha, consuma, teste e consolide — sem travar no meio do caminho.
        </p> */}
      </header>

      <div className="features-list">
        {/* Feature 01 */}
        <div className="feature-row normal">
          <div className="feature-text">
            <h3 className="feature-title">
              <span className="feature-step">01</span>
              Escolha uma história
            </h3>

            {/* <p className="feature-description">
              Nada de lição chata ou historinha infantil. Escolha entre insights
              de bestsellers, autobiografias inspiradoras, explicações de gírias
              locais pra falar como um nativo, mini-histórias pra quando a
              preguiça bate — e muito mais. <strong>Tudo no seu nível (A1–B2)</strong> e do seu jeito.
            </p>

            <p className="feature-description">
              Aprenda um idioma enquanto consome conteúdo que você realmente
              gosta. <strong>Dois objetivos, um só tempo.</strong>
            </p> */}

            <p className="feature-description">
            Chega de aprender sem contexto. Escolha uma história no seu nível (A1–B2) e aprenda no contexto real — do jeito que o idioma é usado de verdade.
            </p>

            <p className="feature-description">
            <strong>Assim você sai dos exercícios aleatórios e entra no idioma de verdade.</strong>
            </p>
          </div>

          <div className="feature-image">
            <img src={exampleImage1} alt="Escolha uma história" />
          </div>
        </div>

        {/* Feature 02 */}
        <div className="feature-row reverse">
          <div className="feature-text">
            <h3 className="feature-title">
              <span className="feature-step">02</span>
              Leia, ouça e entenda (sem travar)
            </h3>

            <p className="feature-description">
            <strong>Não entendeu uma parte?</strong> Sem estresse. Ative a tradução em
              português, escute o áudio com pronúncia natural e acompanhe o texto
              pra não se perder.
            </p>

            <p className="feature-description">
            <strong>Quer ir mais fundo?</strong> Toque em qualquer palavra pra
              ver mais detahles (como a conjugação) ou salvar direto nos
              seus flashcards personalizados.
            </p>
          </div>

          <div className="feature-image">
            <img src={exampleImage2} alt="Leia e ouça histórias" />
          </div>
        </div>

        {/* Feature 03 */}
        <div className="feature-row normal">
          <div className="feature-text">
            <h3 className="feature-title">
              <span className="feature-step">03</span>
              Teste o que aprendeu
            </h3>

            <p className="feature-description">
              No fim da história, treine as palavras mais importantes com
              flashcards e faça um quiz rápido pra testar sua compreensão.
            </p>

            <p className="feature-description">
            <strong>Cada revisão rápida reforça o que você acabou de ver</strong> — pra fixar de vez na memória.
            </p>
          </div>

          <div className="feature-image">
            <img src={exampleImage3} alt="Teste o que aprendeu" />
          </div>
        </div>

        {/* Feature 04 */}
        <div className="feature-row reverse">
          <div className="feature-text">
            <h3 className="feature-title">
              <span className="feature-step">04</span>
              Expanda seu vocabulário
            </h3>

            <p className="feature-description">
              Seus flashcards são <strong>100% personalizados.</strong> Você salva apenas as
              palavras que realmente fazem sentido pra você.
            </p>

            <p className="feature-description emphasis">
              Revise com repetição espaçada inteligente, focando mais no que
              você ainda erra — pra memorizar com eficiência.
            </p>
          </div>

          <div className="feature-image">
            <img src={exampleImage4} alt="Expanda seu vocabulário" />
          </div>
        </div>
      </div>

      {/* Closing */}
      <div className="features-closing">
        {/* <h3 className="features-closing-title">
          <span className="shiny-text">Aprenda</span> um idioma e expanda sua
          mente — história por história.
        </h3>

        <p className="features-closing-subtitle">
          Porque aprender um idioma não precisa ser chato. Aprenda enquanto
          consome conteúdos que você já teria vontade de ler. Uma única história
          curta já expande seu vocabulário com dezenas de palavras em contexto
          real.
        </p> */}

        <div className="hiw__cta_features">
        <button
          className="topfold-cta"
          data-tally-open="mYN7Dz"
          data-tally-layout="modal"
          data-tally-hide-title="1"
          onClick={() => {
            if (!window.Tally) window.open("https://tally.so/r/mYN7Dz", "_blank", "noopener,noreferrer");
          }}
        >
          Entre na lista
        </button>
        </div>

        {/* <div className="hiw__cta">
          <Link to="/signup" className="btn start-btn">
            Comece grátis
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default FeatureSection1;

